import Konva from "konva";

// Tools
const weatherApi = require("../../Tools/WeatherApi");

export class GeneratedWeather {
  constructor() {
    this.layer = new Konva.Layer();
    this.params = [];
    this.entraxe = 3;
    this.size = 28;
    this.sizeIcon = 28;
    this.maxW = 0;
    this.maxH = 0;
    this.colorIcon = false;
    this.totalWidth = 0;
    this.totalHeight = 0;
    this.position = false;
    this.orientation = false;
    this.font = "";
    this.color = "";
    this.nbDay = 0;
  }

  initVal(fullParams) {
    return new Promise((resolve) => {
      this.params = fullParams.params;
      this.entraxe = fullParams.entraxe;
      this.size = fullParams.size;
      this.sizeIcon = fullParams.sizeIcon;
      this.maxW = fullParams.maxW;
      this.maxH = fullParams.maxH;
      this.colorIcon = fullParams.colorIcon;
      this.totalWidth = fullParams.totalWidth;
      this.totalHeight = fullParams.totalHeight;
      this.position = fullParams.position;
      this.orientation = fullParams.orientation;
      this.font = fullParams.font;
      this.color = fullParams.color;
      this.nbDay = fullParams.nbDay;

      return resolve();
    });
  }

  changParams() {
    this.layer.destroy();

    const group = new Konva.Group({
      scaleX: 1,
      scaleY: 1,
      draggable: true,
      dragBoundFunc: function (pos) {
        // TODO: IN THIS FUNCTION OR ON BELOW RESPONSIBLE FOR MOVING WHEN PLAYER IS ON
        return {
          x: pos.x,
          y: pos.y,
        };
      },
    });

    this.params.forEach((element) => {
      const data = localStorage["weather" + element.name.charAt(0).toUpperCase() + element.name.slice(1)];
      let text;

      // IF PARAMS VALUE IS TRUE WE ADD TEXT OR ICON IN GROUP
      if (element.value && data !== undefined) {
        switch (element.name) {
          case "icon":
            text = "./weather_icons/" + data.toString() + ".png";
            break;
          case "temp":
            text = Math.round(data) + "°C";
            break;
          case "sunrise":
            text =
              ("0" + (new Date(data * 1000).getUTCHours() + 1)).slice(-2) +
              ":" +
              ("0" + (new Date(data * 1000).getUTCMinutes() + 1)).slice(-2);
            break;
          case "sunset":
            text =
              ("0" + (new Date(data * 1000).getHours() + 1)).slice(-2) +
              ":" +
              ("0" + (new Date(data * 1000).getMinutes() + 1)).slice(-2);
            break;
          case "windSpeed":
            // convert m/s to km/h
            text = Math.round(data * 3.6) + "km/h";
            break;
          case "humidity":
            text = data + "%";
            break;
          default:
            text = data.charAt(0).toUpperCase() + data.slice(1);
            break;
        }

        const object = this.generatedStructure(element.name, text, group, element.icon);
        if (object != null) group.add(object);
      }
    });

    if (group.children.length > 0) {
      if (group.children[0].getClassName() == "Image") {
        group.children[0].height(this.size * this.sizeIcon);
        group.children[0].width(this.size * this.sizeIcon);
        group.children[0].attrs.draggable = true;
        group.children[0].attrs.dragBoundFunc = function (pos) {
          // TODO: IN THIS FUNCTION OR ON BELOW RESPONSIBLE FOR MOVING WHEN PLAYER IS ON
          return {
            x: pos.x,
            y: pos.y,
          };
        };
      }
    } else {
      const object = this.generatedStructure("", "", group, "");
      group.add(object);
    }

    this.layer.add(group);
    this.changeOrientation();

    return this.layer.children[0];
  }

  generatedStructure(name, data, group, icon) {
    let posX = 0;
    const posY = 0;
    this.maxW = 0;
    this.maxH = 0;

    group.children.forEach((element) => {
      if (element !== undefined) {
        posX += element.width() + 10 * this.entraxe;
        if (element.getClassName() == "Group") {
          element.children.forEach((children) => {
            this.setMax(children.width(), children.height());
          });
        } else {
          this.setMax(element.width(), element.height());
        }
      }
    });

    // IF ICON IS TRUE WE ADD ICON IN GROUP (for sunset, sunrise, windSpeed, humidity)
    if (icon) {
      let iconColor = "white";
      if (!this.colorIcon) {
        iconColor = "black";
      }

      this.color = iconColor;

      const pathIcon = "./weather_icons/extra/" + name + "_" + iconColor + ".png";
      const iconExtra = this.addIcon(pathIcon, posX, posY, this.sizeIcon, this.sizeIcon);
      const textExtra = this.addText(data, posX + iconExtra.width() + 5, posY);

      const groupExtra = new Konva.Group({ name: "groupWeather_" + name });
      groupExtra.add(iconExtra);
      groupExtra.add(textExtra);

      if (this.maxW < textExtra.width()) {
        this.maxW = textExtra.width();
      }

      return textExtra;
    } else {
      if (name == "icon") {
        const iconObj = this.addIcon(data, posX, posY, this.maxW, this.maxH);
        return iconObj;
      } else {
        const textObj = this.addText(data, posX, posY);

        if (this.maxW < textObj.width()) {
          this.maxW = textObj.width();
        }

        return textObj;
      }
    }
  }

  changeOrientation() {
    if (this.layer.children.length > 0) {
      this.totalWidth = 0;
      this.totalHeight = 0;
      const totalChildren = this.layer.children[0].children.length;
      this.layer.children[0].children.forEach((element) => {
        if (element.getClassName() == "Text") {
          if (!this.position) {
            element.width(this.maxW);
          }
          this.totalHeight += element.height();
          this.totalWidth += element.width() + 10 * this.entraxe;
        }
        if (element.getClassName() == "Group") {
          this.totalHeight += element.children[1].height();
          this.totalWidth += element.children[0].width() + element.children[1].width() + 5 + 10 * this.entraxe;
        }
      });

      if (this.orientation) {
        this.portrait();
      } else {
        this.landscape(totalChildren);
        this.totalWidth += this.maxW;
      }
    }
  }

  landscape(totalChildren) {
    let i = 0;
    let posX = this.totalHeight;
    this.setMaxMaster(this.layer.children[0].children);
    this.layer.children[0].children.forEach((element, index) => {
      if (element.getClassName() == "Image") {
        if (!this.position) {
          element.height(this.totalHeight);
          element.width(this.totalHeight);
          element.x(0);
          element.y(0);
        } else {
          if (!(index > 0)) {
            posX = this.size * this.sizeIcon * 1.25;
          }
          element.height(this.size * this.sizeIcon);
          element.width(this.size * this.sizeIcon);
          element.x(0);
          element.y(0);
        }
      } else {
        if (this.position) {
          let w = 0;
          if (index == 0) {
            posX = this.size * this.sizeIcon * 1.25;
          }
          if (element.getClassName() == "Group") {
            w = 0;
            element.children.forEach((children) => {
              if (children.getClassName() == "Image") {
                children.x(posX);
                children.y((this.size * this.sizeIcon) / 2 - this.totalHeight / totalChildren / 2);
                w = children.width() + children.x();
                posX += children.width();
              } else {
                children.x(w + 5);
                children.y((this.size * this.sizeIcon) / 2 - this.totalHeight / totalChildren / 2);
                posX += children.width() + 5 + 10 * this.entraxe;
              }
            });
          }
          if (element.getClassName() == "Text") {
            element.x(posX);
            posX += element.width() + 10 * this.entraxe;
            element.y((this.size * this.sizeIcon) / 2 - this.totalHeight / totalChildren / 2);
          }
        } else {
          if (element.getClassName() == "Group") {
            let w = 0;
            element.children.forEach((children, index) => {
              let posY = children.height() * i - 1;
              if (children.getClassName() == "Image") {
                children.x(
                  (this.maxW - (children.width() + element.children[index + 1].width())) / 2 + this.totalHeight + 25
                );
                children.y(posY);
                w = children.width() + children.x();
              } else {
                children.x(w + 5);
                children.y(posY);
              }
            });
          } else {
            let posY = element.height() * i - 1;
            if (i < 0) {
              posY = 0;
            }
            element.x(this.totalHeight + 25);
            element.y(posY);
          }
          i++;
        }
      }
    });
  }

  portrait() {
    let posX = 0;
    this.setMaxMaster(this.layer.children[0].children);

    this.layer.children[0].children.forEach((element, index) => {
      let posY = 0;
      let i = 0;
      let find = false;
      while (i < this.layer.children[0].children.length && !find) {
        if (element == this.layer.children[0].children[i]) {
          find = true;
        }
        if (!find) {
          if (this.layer.children[0].children[i].getClassName() == "Group") {
            posY += this.layer.children[0].children[i].children[0].height();
          } else {
            posY += this.layer.children[0].children[i].height();
          }
          i++;
        }
      }

      if (element.getClassName() == "Image") {
        element.height(this.maxW);
        element.width(this.maxW);
      }

      if (!this.position) {
        if (element.getClassName() == "Group") {
          const length = element.children.length;
          let w = 0;
          this.maxH = 0;

          element.children.forEach((children, index) => {
            if (children.getClassName() == "Image") {
              let posX = (this.maxW - (children.width() + element.children[index + 1].width())) / 2;
              if (posX < 0) {
                posX = 0;
              }
              children.x(posX);
              children.y(posY);
              w += posX + children.width();
            } else {
              children.x(w + 5);
              children.y(posY);
              w += children.width();
            }

            if (this.maxH < children.height()) {
              this.maxH = children.height();
            }

            if (index == length - 1) {
              element.width(w);
              element.height(this.maxH);

              posX = 0;
              w = 0;
              this.maxH = 0;
            }
          });
        } else {
          element.x(0);
          element.y(posY);
          element.width(this.maxW);
        }
      } else {
        if (element.getClassName() != "Image") {
          if (posX == 0 && element.width() > this.maxW) {
            posX = element.width();
          } else if (posX == 0) {
            posX = this.maxW / 2 - element.width() / 2;
          }
          if (element.getClassName() == "Group") {
            const length = element.children.length;
            let w = 0;
            this.maxH = 0;

            element.children.forEach((children, index) => {
              if (children.getClassName() == "Image") {
                children.x(posX);
                children.y(this.maxW);
                posX += children.width();
                w += children.width();
              } else {
                children.x(w + 5);
                children.y(this.maxW);
                posX += children.width() + 5 + 10 * this.entraxe;
                w += children.width();
              }

              if (this.maxH < children.height()) {
                this.maxH = children.height();
              }

              if (index == length - 1) {
                element.width(w);
                element.height(this.maxH);

                posX = 0;
                w = 0;
                this.maxH = 0;
              }
            });
          } else {
            element.x(posX);
            element.y(this.maxW);
            posX += element.width() + 10 * this.entraxe;
          }
        } else if (element.getClassName() == "Image" && index > 0) {
          element.x(posX);
          element.y(0);
        }
      }
    });
  }

  addText(data, posX, posY) {
    const text = new Konva.Text({
      name: "textWeather_" + data,
      x: posX,
      y: posY,
      text: data,
      fontSize: this.size,
      fontFamily: this.font,
      fill: this.color,
      align: "center",
      verticalAlign: "middle",
    });

    return text;
  }

  addIcon(data, posX, posY, width, height) {
    const icon = new Image();
    icon.src = data;

    const image = new Konva.Image({
      name: "iconWeather_" + data,
      x: posX,
      y: posY,
      image: icon,
      width: width,
      height: height,
      scaleX: 1,
      scaleY: 1,
      strokeWidth: 5,
    });

    return image;
  }

  setMaxMaster(parent) {
    parent.forEach((element) => {
      if (element !== undefined) {
        if (element.getClassName() == "Group") {
          const width = element.children[0].width() + element.children[1].width();
          const height = element.children[0].height() + element.children[1].height();
          this.setMax(width, height);
        } else {
          this.setMax(element.width(), element.height());
        }
      }
    });
  }

  setMax(width, height) {
    if (this.maxW < width) {
      this.maxW = width;
    }
    if (this.maxH < height) {
      this.maxH = height;
    }
  }

  /**
   * Get weather from openweather api if data is expired or city different
   * @param {Object} dataWeather
   * @description Write in the local storage the weather data
   */
  getWeather(dataWeather) {
    return new Promise((resolve, reject) => {
      this.initVal(dataWeather.fullParams);

      const date = new Date();
      const currentDate = date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
      const currentHour = date.getHours();

      if (dataWeather.nbDay === undefined) {
        dataWeather.nbDay = 0;
      }

      // If city is equal and on the same day and we are under 3 hours we reuse local storage values
      if (
        dataWeather.nbDay == parseInt(localStorage.weatherDay) &&
        dataWeather.city.toLowerCase() == localStorage.weatherCity.toLowerCase() &&
        currentDate == localStorage.weatherDate &&
        currentHour < parseInt(localStorage.weatherHour, 10) + 3
      ) {
        // We already have the datas in local storage
        return resolve();
      } else {
        const config = {
          city: dataWeather.city,
          units: "metric",
          lang: "fr",
        };

        if (dataWeather.nbDay < 0 || isNaN(dataWeather.nbDay)) {
          dataWeather.nbDay = 0;
        }

        if (dataWeather.nbDay > 7) {
          dataWeather.nbDay = 7;
        }

        const day = dataWeather.nbDay;

        weatherApi
          .getWeather(config)
          .then((response) => {
            localStorage.weatherDate = currentDate;
            localStorage.weatherHour = currentHour;
            localStorage.weatherDay = day;
            localStorage.weatherIcon = response[day].icon;
            localStorage.weatherTemp = response[day].temp;
            localStorage.weatherCity = response[day].city;
            localStorage.weatherRain = response[day].rain;
            localStorage.weatherHumidity = response[day].humidity;
            localStorage.weatherSunrise = response[day].sunrise;
            localStorage.weatherSunset = response[day].sunset;
            localStorage.weatherWindDirection = response[day].wind_direction;
            localStorage.weatherWindSpeed = response[day].wind_speed;
            return resolve();
          })
          .catch((err) => {
            return reject("get weather failed:", err);
          });
      }
    });
  }
}
